__turbopack_context__.v({
  "footer_description": "login-form-card-module-scss-module__NMGsvq__footer_description",
  "forgot": "login-form-card-module-scss-module__NMGsvq__forgot",
  "status": "login-form-card-module-scss-module__NMGsvq__status",
});
